/**
 * Allowlist of origins SSO is willing to hand a sign-in token back to. This is
 * the primary defense against open-redirect token theft (the user-insights
 * mint endpoint enforces the same policy server-side as a second layer).
 *
 * Keep in sync with the frontends listed in the backends' CORS configs.
 */
const ALLOWED_ORIGIN_PATTERNS: RegExp[] = [
  /^https:\/\/([\w-]+\.)*augmoto\.com$/,
  /^https:\/\/([\w-]+\.)*augmodo\.com$/,
  /^https:\/\/[\w-]+--staging-labeling-tools\.netlify\.app$/,
  /^https:\/\/[\w-]+--staging-product-catalog\.netlify\.app$/,
  // store-management: staging root plus its per-branch preview aliases.
  /^https:\/\/([\w-]+--)?staging-store-management\.netlify\.app$/,
  /^https:\/\/store-managements\.netlify\.app$/,
  /^https:\/\/[\w-]+--labeling-status\.netlify\.app$/,
  /^https:\/\/labeling-status\.netlify\.app$/,
  /^https:\/\/staging-product-catalog\.netlify\.app$/,
  /^https:\/\/labeling-tools-[\w-]+\.netlify\.app$/,
  /^https:\/\/([\w-]+--)?labeling-tools-[\w-]+-staging\.netlify\.app$/,
  ...(import.meta.env.DEV ? [/^http:\/\/(localhost|127\.0\.0\.1):\d+$/] : []),
];

export function validateRedirectUri(raw: string | null): URL | null {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.username || url.password) return null;
  return ALLOWED_ORIGIN_PATTERNS.some((p) => p.test(url.origin)) ? url : null;
}
